import "./index.scss";
import { CfCard07Props } from "./types";
import { ContentfulLivePreview } from "@contentful/live-preview";
import { GeneralSmallArrowRight } from "@wise-emotions/react-icons";
import { LiveInspectorData } from "types/types";
import { useContentfulLiveUpdates } from "@contentful/live-preview/react";
import IconWrap from "components/Icon/IconWrap";
import React from "react";
import classNames from "classnames";
import parse from "html-react-parser";

const Card07 = (props: CfCard07Props) => {
  const {
    abstract,
    hasParentLink = true,
    headingLabelType,
    headingLabelInfo,
    image,
    labelCta,
    title,
  } = useContentfulLiveUpdates({
    ...props,
    sys: { id: props.contentful_id },
  });
  // abstract
  const text =
    typeof abstract === "string" ? abstract : (abstract?.abstract ?? "");
  const titleProps = title || "";
  // hasParentLink
  const cardCls = classNames("Card07", "box-shadow-card", {
    "Card07--has-parent-link box-shadow-card--hasHover": hasParentLink,
  });
  // hasLabelType
  const labelTypePresent = !!headingLabelType;
  // hasLabelInfo
  const labelInfoPresent = !!headingLabelInfo;
  const headingIsPresent = labelInfoPresent || labelTypePresent;
  const labelTypeCls = classNames("Card07__heading-type");
  const labelInfoCls = classNames("Card07__heading-info");
  // image
  const imageUrl = image?.[0]?.imageDesktop?.file?.url;
  // labelCta
  const cta = labelCta?.[0]?.text?.text ?? "";

  const liveInspector: LiveInspectorData = {
    card: ContentfulLivePreview.getProps({
      entryId: props.contentful_id || "",
      fieldId: "entryTitle",
    }),
  };

  return (
    <div className={cardCls} {...liveInspector?.card}>
      <div className="Card07__image-container">
        <div className="Card07__image-background">
          <div
            data-testid="image"
            className="Card07__image-background__img"
            style={{ backgroundImage: `url(${imageUrl})` }}
          />
          {/* <div className="Card07__image-gradient" /> */}
        </div>
      </div>
      <div className="Card07__wrapper">
        {headingIsPresent && (
          <div className="Card07__heading-wrapper">
            {labelTypePresent && (
              <div className={labelTypeCls}>{headingLabelType}</div>
            )}
            {labelInfoPresent && (
              <div className={labelInfoCls}>{headingLabelInfo}</div>
            )}
          </div>
        )}
        <div className="Card07__title">{parse(titleProps)}</div>
        <div className="Card07__text">{parse(text)}</div>
      </div>
      <div className="Card07__cta">
        <span>{cta}</span>
        <IconWrap>
          <GeneralSmallArrowRight />
        </IconWrap>
      </div>
    </div>
  );
};

export default Card07;
